const applyCounterForTextareas = () => {
  function applyCounter(el) {
    const counter = document.getElementById(`${el.id}_counter`);

    el.addEventListener('keyup', () => {
      counter.innerText = `${el.value.length}/1000`;
    });
  }

  const decline = document.getElementById('message');
  const blackout = document.getElementById('blackout_reason');
  const main = document.getElementsByClassName('main')[0];

  if (main && blackout) {
    main.style = 'background-color: #f1f2f4';
    [decline, blackout].forEach((el) => { applyCounter(el); });
  }
};

export default applyCounterForTextareas;
